<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>金料单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="query" ref="query" label-width="90px" class="search-form">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col style="width: 150px">
            <el-input v-model="query.keyword" @keyup.enter="fetchs" prefix-icon="Search"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-col>
            <!-- <el-cascader v-model="companyId" :options="companys" clearable @change="fetchs" /> -->
            <el-tree-select ref="companys" v-model="companyId" :data="companys" @change="fetchs();"
              check-strictly :render-after-expand="false" style="min-width: 210px;" />
          </el-col>
        </el-form-item>

        <el-form-item label="单据时间">
          <el-col>
            <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
              unlink-panels :shortcuts="$util.getShortCuts()" @change="fetchs()" style="max-width:210px;">
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="操作类型" prop="billType">
          <el-col>
            <el-select v-model="billType" placeholder="请选择操作类型" clearable @change="fetchs" style="width: 150px">
              <el-option v-for="item in dict.billTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="单据状态" prop="status">
          <el-col>
            <el-select v-model="status" placeholder="请选择单据状态" @change="fetchs" clearable style="width: 150px">
              <el-option key="待确认" label="待确认" value="0"></el-option>
              <el-option key="已入库" label="已入库" value="1"></el-option>
              <el-option key="已归档" label="已归档" value="50"></el-option>
              <el-option key="已取消" label="已取消" value="-1"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="Search" @click="fetchs()">
            搜索
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="CirclePlus" @click="$router.push({ path: 'purchase', query: {} })">
        新建采购申请单
      </el-button>
      
      <el-button type="primary" icon="CirclePlus" @click="$router.push({ path: 'stored', query: {} })">
        新建金料采购单
      </el-button>
      <el-button type="primary" icon="FirstAidKit" @click="$router.push({ path: 'dispatched', query: {} })">
        新建工厂送料单
      </el-button>
      <el-button type="primary" icon="FirstAidKit" @click="$router.push({ path: 'received', query: {} })">
        新建工厂回货单
      </el-button>
      <el-button type="success" icon="ScaleToOriginal" @click="$router.push({ path: 'adjusted', query: {} })">
        新建金料调整单
      </el-button>
    </div>

    <basic-table ref="table" class="table" :query="query" @handler="fetchs">
      <template v-slot:status="scope">
        <el-link v-if="scope.row.status == 0" type="primary" size="small" disabled>待确认</el-link>
        <el-link v-else-if="scope.row.status == 1" type="primary" size="small" disabled>已入库</el-link>
        <el-link v-else-if="scope.row.status == 2" type="primary" size="small" disabled>已送料</el-link>
        <el-link v-else-if="scope.row.status == 50" type="success" size="small" disabled>已归档</el-link>
        <el-link v-else-if="scope.row.status == -1" type="danger" size="small" disabled>已取消</el-link>
        <el-link v-else type="info" size="small" disabled>其他</el-link>
      </template>

      <template v-slot:toolbar="scope">
        <el-link @click="watch(scope.row)" type="primary" size="small" style="margin:5px;">查看</el-link>
        <el-link @click="delRow(scope.row)" type="primary" size="small" v-if="scope.row.status == 0"
          style="margin:5px;">删除</el-link>
      </template>
    </basic-table>
  </el-card>
</template>

<script>
import { } from "@/api/stock";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
export default {
  name: "StockMaterialBill",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      dateRange: [],
      query: {
        keyword: "",
        columns: [
          { type: "selection", width: "55" },
          { type: "index", label: "序号" },
          { prop: "billType", label: "单据类型", sortable: true, searchable: true, width: "90", showOverflowTooltip: true, },
          { prop: "billCode", label: "单据编号", sortable: true, searchable: true, width: "150", showOverflowTooltip: true, },
          { prop: "materialName", label: "材质", width: "65", showOverflowTooltip: true, },
          { prop: "totalNumber", label: "重量", width: "70", },
          { prop: "unitPrice", label: "单价", width: "90", permission: 2, },
          { prop: "totalPrice", label: "总价", width: "90", },
          { prop: "billDate", label: "单据时间", width: "150", sortable: true, showOverflowTooltip: true },
          { type: "template", prop: "status", label: "状态", width: "70", searchable: true, },

          { prop: "factoryName", label: "工厂", searchable: true, width: "170", showOverflowTooltip: true, permission: 2, },
          { prop: "departmentNames", label: "渠道部门", searchable: true, width: "200", showOverflowTooltip: true },
          { prop: "remark", label: "备注", searchable: true, width: "110", showOverflowTooltip: true },

          { prop: "createDate", label: "创建时间", width: "150", sortable: true, showOverflowTooltip: true },
          { prop: "createUserName", label: "创建人", width: "80", },
          { type: "toolbar", label: "操作", width: "140" },
        ],
        filters: [],
        sidx: "id",
        sord: "desc"
      },

      status: '',
      companys: [],
      companyId: '',
      billType: '',
      dict: {
        billTypes: [],
      },
    };
  },
  mounted() {
    //kaung插件初始化
    this.$kaung.init(this.$options.name);

    this.$kaung.dictionary("stock", "material").then((res) => { this.dict.billTypes = res; });
    this.$kaung.companys().then((res) => {
      this.companys = res;
      this.fetchs();
    });
  },
  methods: {
    fetchs() {
      this.query.filters = [];
      if (this.billType) {
        this.query.filters.push({ name: "billType", value: this.billType, operate: 0, });
      }
      if (this.companyId) {
        this.query.filters.push({ name: "companyId", value: this.companyId, operate: 0, });
      }
      if (this.status) {
        this.query.filters.push({ name: "status", value: this.status, operate: 0, });
      }
      if (this.dateRange && this.dateRange[0]) {
        this.query.filters.push({ name: "billDate", value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"), operate: 2 });
      }
      if (this.dateRange && this.dateRange[1]) {
        this.query.filters.push({ name: "billDate", value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59", operate: 4 });
      }

      let { data, records, total, ...params } = { ...this.query };
      this.$kaung.search(params).then((res) => {
        this.query = { ...res.data };
      });
    },
    watch(row) {
      if (row.billType.indexOf("采购") > -1)
        this.$router.push({ path: "stored", query: { id: row.id } });
      else if (row.billType.indexOf("送料") > -1)
        this.$router.push({ path: "dispatched", query: { id: row.id } });
      else if (row.billType.indexOf("回货") > -1)
        this.$router.push({ path: "received", query: { id: row.id } });
    },
    delRow(row) {
      let that = this;
      this.$confirm("此操作将删除本页选择数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (row.status == 1) {
            that.$message({
              type: "info",
              message: "删除失败，已审核单据不允许删除",
            });
            return;
          }

          this.$kaung.delete(row.id).then((res) => {
            if (res.code === 200) {
              that.$message({
                type: "success",
                message: "删除成功",
              });
              that.fetchs();
            }
          });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "删除失败",
          });
        });
    },
  },
  watch: {
    companyId: function (newValue, oldValue) {
      if (newValue && newValue != oldValue)
        this.$util.setLocalstorage('companyIdStr', newValue);
      else
        this.$util.setLocalstorage('companyIdStr', '');
    },
    billType: function (newValue, oldValue) {
      if (newValue != oldValue)
        this.$util.setPageCache('billType', newValue);
    },
    status: function (newValue, oldValue) {
      if (newValue != oldValue)
        this.$util.setPageCache('status', newValue);
    }
  },
  created: function () {
    let companyIdStr = this.$util.getLocalstorage('companyIdStr');
    if (companyIdStr != '' && (this.companyId == null || this.companyId.length == 0)) {
      this.companyId = companyIdStr;
    }
    this.query.keyword = this.$util.getPageCache('keyword');
    this.billType = this.$util.getPageCache('billType') || "";
    this.status = this.$util.getPageCache('status');
  }
};
</script>

<style lang="less"></style>

